import type { ClassDefinition } from '../../shared/game/class-types.js';

// Mage 3.0 draft, level 1: Elemental Spellcasting (the Fire, Ice and Lightning cantrips). Mana, tiered spells, Talented Researcher,
// Spellshaper and subclasses begin at later levels and are not implemented yet; Heart's Fire's 1-mana reaction waits for mana.
export const mage: ClassDefinition = {
  id: 'mage', name: 'Mage',
  summary: 'A brilliant spellcaster with power over the elements: fire from afar, ice that hinders, lightning that bites back.',
  keyStats: ['intelligence', 'will'], hitDie: 6, startingHp: 10,
  saves: { advantage: ['intelligence'], disadvantage: ['strength'] },
  armor: ['cloth'], weapons: ['dexterity'], weaponTypes: ['wand', 'staff'],
  startingGear: ['Adventurer’s Garb', 'Staff', 'Soap'], defaultStance: 'keep-distance',
  abilities: [
    {
      id: 'flame-dart', spell: true, name: 'Flame Dart', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Fire cantrip · Range 10 · 1d10 fire. On crit: Smoldering.',
    },
    {
      id: 'ice-lance', spell: true, name: 'Ice Lance', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Ice cantrip · Range 12 · 1d6 cold. The target is Slowed: half speed for one round.',
    },
    {
      id: 'zap', spell: true, name: 'Zap', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Lightning cantrip · Range 8 · 1d8 + 4 lightning. On a miss, you take half the damage instead.',
    },
    {
      id: 'snowblind', spell: true, name: 'Snowblind', level: 1, actions: 1, target: 'enemy', autocast: true,
      description: 'Ice cantrip · Reach 1 · 1d6 cold. The target is Blind for one round: its attacks have disadvantage, attacks against it advantage.',
    },
    {
      id: 'overload', spell: true, name: 'Overload', level: 1, actions: 1, target: 'self', combatOnly: true, autocast: true,
      description: 'Lightning cantrip · Only while Charged, ending it · Reach 2 AoE · 2d8 lightning to every other creature, allies too. Never misses or crits.',
    },
    {
      id: 'hearts-fire', spell: true, name: 'Heart’s Fire', level: 1, actions: 1, target: 'ally', oncePerRound: true, combatOnly: true, autocast: true,
      description: 'Fire cantrip · Range 4 · Give an ally 1 action. Once per round.',
    },
  ],
  passives: [{
    id: 'elemental-spellcasting', name: 'Elemental Spellcasting', level: 1,
    description: 'You know the Fire, Ice and Lightning cantrips.',
  }],
};
